/* eslint-disable @typescript-eslint/naming-convention */
export class Search {
  constructor(public search_string?: string, public newspaper?: string) {}
}
